import { render, staticRenderFns } from "./Zugang.vue?vue&type=template&id=3ea65413&scoped=true"
import script from "./Zugang.vue?vue&type=script&lang=js"
export * from "./Zugang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea65413",
  null
  
)

export default component.exports